import { render } from "./ClaimsInstructionsByDevice.vue?vue&type=template&id=f5b3cb16&ts=true"
import script from "./ClaimsInstructionsByDevice.vue?vue&type=script&lang=ts"
export * from "./ClaimsInstructionsByDevice.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__